export const settings = {
    settingsEnabled: true,
    i18n: {
        fallbackLng: 'en',
        supportedLngs: ['en', 'pl'],
    },
};
